import type { U3139FindSearchCadastreItem } from '../../U3139Service';

/** Libellé suggestion cadastre avec district pour désambiguïser (BL-0102). */
export function u3139FindSearchCadastreItemToDisplay(item: unknown): string {
  if (!item || typeof item !== 'object') return '';
  const rec = item as U3139FindSearchCadastreItem;
  const rank = rec.rankLabel?.trim() || rec.rankCode?.trim() || '';
  const cadastreBase = rec.cadastre?.trim() ?? '';
  const cadastreLabel = cadastreBase && rank ? `${cadastreBase} ${rank}` : cadastreBase;
  const districtLabel = rec.district?.propertyDistrict?.trim() ?? '';
  if (cadastreLabel && districtLabel) return `${cadastreLabel} (${districtLabel})`;
  return cadastreLabel || districtLabel;
}
